import LogoutIcon from "@mui/icons-material/Logout";
import type { PopoverProps } from "@mui/material";
import { Avatar, Box, Divider, ListItemIcon, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import type { AgentResponse } from "../admin/agents/agentsApi";
import type { CustomerContext } from "../auth/auth";
import { auth } from "../auth/auth";
import { LoyaltyPointsInfoMobile } from "./LoyaltyPointsInfoMobile";

export function TopmostBarMenu({
  anchorEl,
  open,
  onClose,
  agent,
  context,
}: {
  anchorEl: PopoverProps["anchorEl"];
  open: boolean;
  onClose: () => void;
  agent?: AgentResponse | null;
  context: CustomerContext | null;
}) {
  const queryClient = useQueryClient();
  const logout = async () => {
    if (confirm("Czy chcesz się wylogować?")) {
      await auth.signOut();
      queryClient.clear();
    }
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 8px 24px rgba(0,0,0,0.12))",
            mt: 1.5,
            minWidth: 280,
            borderRadius: 1.5,
            "& .MuiAvatar-root": {
              width: 40,
              height: 40,
              ml: -0.5,
              mr: 2,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <LoyaltyPointsInfoMobile context={context} />

      <Divider sx={{ my: 1, display: { xs: "block", sm: "none" } }} />

      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          Twój doradca klienta
        </Typography>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            mt: 1.5,
            mb: 0.5,
          }}
        >
          <Avatar src="https://picsum.photos/seed/opiekun/100/100" />
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: "bold",
              }}
            >
              {agent?.name}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                lineHeight: 1,
              }}
            >
              Wsparcie sprzedaży i konfiguracji oferty
            </Typography>
            <Typography
              variant="h6"
              component="a"
              href={agent?.contact.phone ? `tel:${agent.contact.phone.replace(/\s+/g, "")}` : undefined}
              sx={{
                fontWeight: "bold",
                textDecoration: "none",
                color: "text.primary",
                "&:hover": { color: "primary.main" },
              }}
            >
              {agent?.contact.phone}
            </Typography>
          </Box>
        </Stack>
      </Box>
      <Divider sx={{ my: 1 }} />
      <MenuItem onClick={logout} sx={{ py: 1.5, color: "error.main" }}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" color="error" />
        </ListItemIcon>
        Wyloguj się
      </MenuItem>
    </Menu>
  );
}
